import { render, staticRenderFns } from "./CreateReviewFlow.vue?vue&type=template&id=474c7fc7&"
import script from "./CreateReviewFlow.vue?vue&type=script&lang=js&"
export * from "./CreateReviewFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports